import React from "react";

import { LoadingSpinner, StyledButton } from "./styled";
import type { ButtonProps } from "./types";

export const Button: React.FC<ButtonProps> = ({
  children,
  size = "medium",
  variant = "solid",
  disabled = false,
  loading = false,
  onClick,
  type = "button",
  className,
  testId,
  styleProps,
  ...props
}) => {
  return (
    <StyledButton
      $size={size}
      $variant={variant}
      $styleProps={styleProps}
      disabled={disabled || loading}
      {...(onClick && { onClick })}
      type={type}
      {...(className && { className })}
      data-testid={testId}
      {...props}
    >
      {loading && <LoadingSpinner />}
      {children}
    </StyledButton>
  );
};
